import {Component} from '@angular/core';
import {ResultDTOService} from '../../../@core/utils/result-dto.service';
import {ColumnRenderStatusComponent} from './column-render-status.component';
import {Router} from '@angular/router';
import {ImportFileService} from '../../../@theme/components/import-file/import-file.service';

@Component({
  selector: 'ngx-result-import',
  templateUrl: './result-import.component.html',
  styleUrls: ['./result-import.component.scss'],
})
export class ResultImportComponent {

  public results = [];

  settings = {
    actions: {
      columnTitle: 'Ações',
      add: false,
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
      confirmSave: true,
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      name: {
        title: 'Nome',
        type: 'string',
      },
      email: {
        title: 'E-mail',
        type: 'string',
      },
      group: {
        title: 'Grupo',
        type: 'string',
      },
      role: {
        title: 'Permissão',
        type: 'string',
      },
      success: {
        title: 'Status',
        type: 'custom',
        renderComponent: ColumnRenderStatusComponent,
        filter: false,
        editable: false,
      },
    },
    noDataMessage: 'Nenhum registro encontrado',
  };

  constructor(private resultDTOService: ResultDTOService, private router: Router,
              private importFileService: ImportFileService) {
    this.getAll();
  }


  getAll() {
    this.results = this.resultDTOService.getAll();
    if (!this.results || this.results.length === 0) {
      this.router.navigate(['pages/admin/user']);
    }
  }


  onEditConfirm(event): void {
    this.importFileService.reimport(event.newData).toPromise().then(result => {
      alert('OK');
    });
  }

  onDeleteConfirm(event): void {
    if (window.confirm('Are you sure you want to delete?')) {
      event.confirm.resolve();
    } else {
      event.confirm.reject();
    }
  }
}
